<app-header *ngIf="!isGuestMode"></app-header>

<app-main [class.guest-mode]="isGuestMode"></app-main>